import {
    ChangeDetectionStrategy,
    Component,
    input,
    output,
    signal,
} from '@angular/core';

@Component({
    selector: 'telxl-search',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './search.component.html',
    styleUrl: './search.component.scss',
})
export class TelXLSearchComponent {
    searchText = input<string>();
    id = input<string>();
    disabled = input<boolean>(false);
    searchTextChange = output<string>();
    isFocused = signal(false);

    onInput(event: Event): void {
        const input = event.target as HTMLInputElement;
        this.searchTextChange.emit(input.value);
    }
}
